<div class="wrap mt-4">
  <app-partner-portal-info-blocks class="w-100 d-block position-relative mt-2 border-bottom"></app-partner-portal-info-blocks>
  <div class="container py-3">
    <div class="row p-3">
      @if (id) {
        <app-cms-page-content carousel class="col" [pageId]="id" [showNotFound]="false"></app-cms-page-content>
      }
    </div>
  </div>
  <div class="container px-3">
    <div class="bottom-content mb-5 px-4">
      @if (id_bottom) {
        <app-cms-page-content carousel class="col" [pageId]="id_bottom" [showNotFound]="false"></app-cms-page-content>
      }
    </div>
  </div>
</div>
